import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { Utente } from 'src/app/main/_models/utente';
import { AuthenticationService } from './authentication.service';

@Injectable({
	providedIn: 'root'
})
export class ClientLogService {

	constructor(private http: HttpClient,
		private config: AppConfig,
		private authenticationService: AuthenticationService) { }

	error(data: any) {
		return this.log(data, "ERROR");
	}

	info(data: any) {
		return this.log(data, "INFO");
	}

	warning(data: any) {
		return this.log(data, "WARNING");
	}

	log(data: any, level: string) {
		const toLog = <LogClientPostData>{ "level": level, "username": this.authenticationService.currentUserValue? this.authenticationService.currentUserValue.username : null, "data": data };
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/log/client`, toLog);
	}
}

export interface LogClientPostData {
	level: string;
	username: string;
	data: any;
}